const DEFAULT_ALPHA_THRESHOLD = 10;

function getTrimBounds(
    ctx: CanvasRenderingContext2D,
    w: number,
    h: number,
    alphaThreshold: number,
): { xMin: number; yMin: number; cropW: number; cropH: number } | null {
    const d = ctx.getImageData(0, 0, w, h).data;
    let xMin = w;
    let xMax = 0;
    let yMin = h;
    let yMax = 0;
    for (let y = 0; y < h; y++) {
        for (let x = 0; x < w; x++) {
            if (d[(y * w + x) * 4 + 3] > alphaThreshold) {
                xMin = Math.min(xMin, x);
                xMax = Math.max(xMax, x);
                yMin = Math.min(yMin, y);
                yMax = Math.max(yMax, y);
            }
        }
    }
    const cropW = xMax - xMin + 1;
    const cropH = yMax - yMin + 1;
    if (cropW <= 0 || cropH <= 0) return null;
    return { xMin, yMin, cropW, cropH };
}

/**
 * Обрезает изображение по границам пикселей с alpha > threshold.
 * Для saveProject() — уменьшает размер картинок в payload.
 */
export function cropToNonEmptyPixels(
    dataURL: string,
    alphaThreshold: number = DEFAULT_ALPHA_THRESHOLD,
): Promise<string> {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
            const w = img.width;
            const h = img.height;
            const canvas = document.createElement('canvas');
            canvas.width = w;
            canvas.height = h;
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                reject(new Error('Canvas 2D not available'));
                return;
            }
            ctx.drawImage(img, 0, 0);
            const bounds = getTrimBounds(ctx, w, h, alphaThreshold);
            if (!bounds) {
                resolve(dataURL);
                return;
            }
            const { xMin, yMin, cropW, cropH } = bounds;
            const cropped = ctx.getImageData(xMin, yMin, cropW, cropH);
            const out = document.createElement('canvas');
            out.width = cropW;
            out.height = cropH;
            const outCtx = out.getContext('2d');
            if (!outCtx) {
                reject(new Error('Canvas 2D not available'));
                return;
            }
            outCtx.putImageData(cropped, 0, 0);
            resolve(out.toDataURL('image/png'));
        };
        img.onerror = () => reject(new Error('Image load failed'));
        img.src = dataURL;
    });
}
